// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Grid,
  Box,
  Button,
  AvatarGroup,
  Avatar,
  Image,
  Icon,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";

// Assets

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import FilesList from "components/FilesList/List";

import React,{useEffect, useState} from "react";
import { useLocation } from "react-router-dom";

function Tables() {
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState('1');
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab) {
      setCurrentTab(tab);
    }
  }, [location.search]);

  
  const tabs = [
      {
          id: 1,
          tabTitle: 'تصاویر',
          title: 'تصاویر',
          content: FilesList({type:"image"})
          
      },
      {
          id: 2,
          tabTitle: 'ویدیو',
          title: 'ویدیو',
          content: FilesList({type:"video"})
      },
      {
          id: 3,
          tabTitle: 'صوت',
          title: 'صوت',
          content: FilesList({type:"audio"})
      },
      {
          id: 4,
          tabTitle: 'مستندات',
          title: 'مستندات',
          content: FilesList({type:"files"})
      }
  ];

  const handleTabClick = (e) => {
      setCurrentTab(e.target.id);
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0">
        <CardHeader p="6px 0px 22px 0px">
          <Text fontSize="md" color={textColor} fontWeight="bold">
            مدیریت فایل‌ها
          </Text>
        </CardHeader>
        <CardBody pb="50px" px='5px'>
        <Box className='container'>
            <Flex mb="20px" className='tabs'>
                {tabs.map((tab, i) =>
                    <Button fontSize={"xs"} ml={"10px"} key={i} id={tab.id} disabled={currentTab === `${tab.id}`} onClick={(handleTabClick)}>{tab.tabTitle}</Button>
                )}
            </Flex>
            <Grid  className='content'>
                {tabs.map((tab, i) =>
                    <div key={i}>
                        {currentTab === `${tab.id}` && <div>{tab.content}</div>}
                    </div>
                )}
            </Grid>
        </Box>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default Tables;
